/**
 * Commission / Finance HQ Excel header strings aligned with API
 * {@code com.v3biomed.api.util.ExcelFieldKeys} (V3 entity labels).
 */
export const EXCEL_COMMISSION_V3_KEYS = {
  MFG_NAME: "V3 Mfg Name",
  PAID_DATE: "V3 Service Fee Paid Date",
  SERVICE_FEE_RECEIVED: "V3 Service Fee Received",
  GROSS_SERVICE_FEE_TOTAL: "V3 Gross Service Fee Total",
  SERVICE_RATE: "V3 Service Rate",
  GROSS_SERVICE_FEE: "Gross V3 Service Fee",
  GROSS_RATE_PERCENT: "V3 Gross Rate %",
} as const;

/** Finance HQ detail export columns (client-generated; not import template keys). */
export const EXCEL_FINANCE_HQ_V3_EXPORT_COLUMNS = {
  SERVICE_FEE_PERCENT: "V3 Service Fee %",
  SERVICE_FEE_AMOUNT: "V3 Service Fee $",
  PAY_STATUS: "V3 Pay Status",
  CLEARED_RECEIVED_DATE: "V3 Cleared & Rcvd Date",
} as const;

export const EXCEL_COMMISSION_DETAILS_V3_LABELS = {
  COSTS_SECTION: "V3 Costs",
  TOTAL_COST: "V3 Total Cost",
  LESS_TOTAL_COST: "Less: V3 Total Cost",
} as const;

export const EXCEL_SALES_V3_LABELS = {
  PAY_STATUS_TO_V3: "Pay Status to V3",
  NET_SERVICE_FEE: "V3 Net Service Fee",
} as const;
